"use strict";
export class SchoolBrandingController {
  constructor(host) {
    this.host = host;
    this.host.addController(this);
  }
  hostUpdated() {
    const currentSchool = this.host.currentSchool;
    if (currentSchool) {
      if (currentSchool.branding_primary_color) {
        document.body.style.setProperty("--hi-clr--university-bkg", currentSchool.branding_primary_color);
      }
      if (currentSchool.branding_secondary_color) {
        document.body.style.setProperty("--hi-clr--university-primary", `${currentSchool.branding_secondary_color}`);
      }
      const textColor = currentSchool.branding_alternate_text_color ? "var(--hi-color--white)" : "var(--hi-color--black)";
      document.body.style.setProperty("--hi-clr--university-text", `${textColor}`);
    }
  }
}
